/* eslint-disable import/prefer-default-export */

import {
  ARTIST_OWNERSHIPS_CHANGED
} from '../constants/myArtistsConstants';

const axios = require('axios').default;
import { toast } from 'react-toastify';

import $ from 'jquery';
require('datatables.net-bs4');

export const artistOwnershipsChanged = (artistOwnerships) => ({
  type: ARTIST_OWNERSHIPS_CHANGED,
  artistOwnerships
});
